import React from 'react';
import { useState } from 'react';
import { Image, Flex } from 'antd';
import CitySH from '@/assets/about/city-sh.jpg';
import CityWH from '@/assets/about/city-wh.jpg';
import CityCC from '@/assets/about/city-cc.jpg';
import { getChildrenToRender } from '@/utils';
import { useTranslation } from 'react-i18next';

function Teams1(props) {
  const { dataSource, isMobile, ...restProps } = props;
  const [selectedOption, setSelectedOption] = useState('A');
  const { t } = useTranslation();
  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div {...restProps} {...dataSource.wrapper}>
      <div {...dataSource.page}>
        <div {...dataSource.titleWrapper}>
          {dataSource.titleWrapper.children.map((val, i) => getChildrenToRender(val, i, t))}
        </div>
        <div className="team-container">
          {
            isMobile ? (
              <Flex vertical>
                <div className="city-container">
                  <Image src={CitySH} objectFit="contain" />
                  <div className="city-name">{t('about.shanghai')}</div>
                  <div className="city-address">{t('about.shanghaiAddressDetail')}</div>
                </div>
                <div className="city-container">
                  <Image src={CityWH} objectFit="contain" />
                  <div className="city-name">{t('about.wuhan')}</div>
                  <div className="city-address">{t('about.wuhanAddressDetail')}</div>
                </div>
                <div className="city-container">
                  <Image src={CityCC} objectFit="contain" />
                  <div className="city-name">{t('about.changchun')}</div>
                  <div className="city-address">{t('about.changchunAddressDetail')}</div>
                </div>
              </Flex>
            ) : (
              <fieldset>
                <label htmlFor="first">
                  <input type="radio" name="check" id="first" value="A" checked={selectedOption === 'A'}
                         onChange={handleRadioChange} />
                  <div className="city-container">
                    <img src={CitySH} height="450px" />
                    <div className="city-name">{t('about.shanghai')}</div>
                    {selectedOption === 'A' &&
                      <div className="city-address">{t('about.shanghaiAddressDetail')}</div>}
                  </div>
                </label>
                <label htmlFor="second">
                  <input type="radio" name="check" id="second" value="B" checked={selectedOption === 'B'}
                         onChange={handleRadioChange} />
                  <div className="city-container">
                    <img src={CityWH} height="450px" />
                    <div className="city-name">{t('about.wuhan')}</div>
                    {selectedOption === 'B' &&
                      <div className="city-address">{t('about.wuhanAddressDetail')}</div>}
                  </div>
                </label>
                <label htmlFor="third">
                  <input type="radio" name="check" id="third" value="C" checked={selectedOption === 'C'}
                         onChange={handleRadioChange} />
                  <div className="city-container">
                    <img src={CityCC} height="450px" />
                    <div className="city-name">{t('about.changchun')}</div>
                    {selectedOption === 'C' && <div className="city-address">{t('about.changchunAddressDetail')}</div>}
                  </div>
                </label>
              </fieldset>
            )
          }
        </div>
      </div>
    </div>
  );
}

export default Teams1;
